import * as React from "react";

import { useDispatch } from 'react-redux';
import { setAnonymousUserZipCode } from '../actions/cartActions';
import SeccondaryHeader from '../styleguide/SecondaryHeader';
import AddressSearch from '../address/AddressSearch';
import PropTypes from 'prop-types';

import styles from '../preRegister/PreRegister.module.css';

/**
 * Prompt user for their address for use later in reg flow
 */
const AddressPrompt = ({onComplete}) => {
 
  const dispatch = useDispatch();
 
  const onAddressSelection = (zipCode) => {
    if (zipCode) {
      dispatch(setAnonymousUserZipCode(zipCode));
    }
    onComplete();
  }
  
  return (
    <div style={{textAlign:'center'}}>
      <SeccondaryHeader isCentered text="Your Address" />
      <div className={styles.inputWrap}>
        <AddressSearch
          buttonText="Submit"
          storageOnly
          onComplete={(zipCode) => {onAddressSelection(zipCode)}} />
      </div>
      <div>
        We'll use your address to determine delivery options and
        save time during&nbsp;sign&nbsp;up.
      </div>
    </div>
  );
}

AddressSearch.propTypes = {
  onComplete: PropTypes.func.isRequired
};

export default AddressPrompt;